"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const utils_1 = require("../utils");
const constants_1 = require("../utils/constants");
const styled_1 = __importDefault(require("../utils/styled"));
const Splash_Animation_1 = __importDefault(require("./Splash.Animation"));
const Splash_Logo_1 = __importDefault(require("./Splash.Logo"));
const Container = styled_1.default("div") `
  z-index: 10000;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  ${({ theme, color }) => `
      background-color: ${constants_1.expandColor(theme, color) || color || theme.color.primary};
  `};
`;
const Content = styled_1.default("div") `
  position: relative;
  ${({ color }) => `
    color: ${utils_1.readableTextColor(color, ["#000", "#FFF"])};
  `};
`;
const TitleBar = styled_1.default("div") `
  max-width: 640px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const TitleBarContent = styled_1.default("div") `
  margin-left: 10px;
  & h1 {
    font-size: 40px;
    line-height: 1;
    font-weight: 400;
    margin: 0 0 15px;
  }
`;
const Static = styled_1.default("div") `
  font-size: 22px;
  max-width: 640px;
  margin: 20px auto;
  text-align: left;
  background-color: rgba(255, 255, 255, 0.15);
  padding: 20px;
  border-radius: 6px;
  & a:link,
  & a:visited {
    color: inherit;
    text-decoration: underline;
  }
  & > *:first-of-type {
    margin-top: 0px;
  }
  & > *:last-child {
    margin-bottom: 0px;
  }
  & p {
    line-height: 1.35;
  }
`;
const Splash = ({ color, logo, children, title, actions }) => {
    return (React.createElement(Container, { color: color },
        React.createElement(Splash_Animation_1.default, { isFullscreen: true }),
        React.createElement(Content, { color: color },
            React.createElement(TitleBar, null,
                React.createElement(Splash_Logo_1.default, { size: 110, logo: logo }),
                React.createElement(TitleBarContent, null,
                    React.createElement("h1", null, title),
                    React.createElement("div", null, actions))),
            React.createElement(Static, null, children))));
};
exports.default = Splash;
//# sourceMappingURL=Splash.js.map